var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDialog",
    {
      attrs: { visible: _vm.dialogVisible, width: "400px" },
      on: {
        close: function ($event) {
          _vm.dialogVisible = false
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "100px",
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("InternalSalesOrderDetails.pickUpTime"),
                prop: "pickUpTime",
              },
            },
            [
              _c("BjDateTimerPicker", {
                attrs: { "picker-options": _vm.pickerOptions },
                model: {
                  value: _vm.form.pickUpTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "pickUpTime", $$v)
                  },
                  expression: "form.pickUpTime",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }